import get from "lodash/get"
import { theme } from "@styles/theme"
import { css, ThemeUICSSObject } from "@theme-ui/css"
import { ThemeUIStyleObject } from "theme-ui"

export const getThemeVariant = (
  variantKey: string,
  variantSelector: string
): Record<string, ThemeUIStyleObject> =>
  get(theme, `${variantKey || "variants"}.${variantSelector}`, {})

export const getThemeVariantStyles = (
  variantKey: string,
  variantSelector: string
): ThemeUIStyleObject =>
  css(getThemeVariant(variantKey, variantSelector) as ThemeUICSSObject)(
    theme
  ) as ThemeUIStyleObject
